/**
 * Created by idea on 03/07/2017.
 */
import {Component} from '@angular/core';

declare var jQuery:any;

@Component({
    selector: 'blank',
    templateUrl: 'blank.template.html'
})

export class blankComponent {
    constructor(){
    }

}



// WEBPACK FOOTER //
// /app/src/app/layout/layouts/blank.component.ts